import { render } from "./postDetail.vue?vue&type=template&id=29e4d2c8&scoped=true&ts=true"
import script from "./postDetail.vue?vue&type=script&lang=ts"
export * from "./postDetail.vue?vue&type=script&lang=ts"

import "./postDetail.vue?vue&type=style&index=0&id=29e4d2c8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/OfferCloud2_FrontWebs_All/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e4d2c8"]])

export default __exports__